import { F as ts } from "./FormCheck-7cf42dfb.js";
import { F as ls } from "./FormInput-7b54778c.js";
import { resolveComponent as m, openBlock as o, createElementBlock as i, createElementVNode as s, toDisplayString as g, createVNode as k, withCtx as y, createTextVNode as O, createCommentVNode as n, normalizeClass as x, normalizeStyle as T, Fragment as N, renderList as L, createBlock as u, resolveDynamicComponent as A, resolveDirective as I, withDirectives as _, vModelText as P, renderSlot as b, vModelSelect as Q, vModelDynamic as E, vModelRadio as J, vModelCheckbox as Y, withModifiers as $, withKeys as j, Transition as Z } from "vue";
import { _ as v } from "./_plugin-vue_export-helper-dad06003.js";
import { M as ee } from "./MagnifyingGlassIcon-14c73a3f.js";
import { _ as F, g as C, F as te, n as z, o as G } from "./CardVideo-e725a421.js";
import { p as ss, q as ns } from "./CardVideo-e725a421.js";
import { p as oe, a as le, B as re, b as se } from "./FormRichText.model-53e072ea.js";
import { C as ne } from "./CardShortcut-d8584bdc.js";
import "./glightbox-13d8fc52.js";
import { a as ie, B as ae } from "./BadgePurpleSm-624c687b.js";
import { B as de } from "./ButtonPayment-c8ced69b.js";
import { H as V } from "./HelpIcon-2069ddad.js";
import { useNotificationHandler as B } from "./useNotificationHandler.js";
import { a as as, F as ds } from "./FormInputDate-84f37c95.js";
import { A as M } from "./AlertCircleIcon-61966fff.js";
import { c as D, f as U } from "./string-30844d53.js";
import { S as ue } from "./FormSelect-346977f1.js";
import { F as cs } from "./FormSelect-346977f1.js";
import { F as fs } from "./FormToggleSm-73b85790.js";
import { C as ce, U as me } from "./CopyDocumentIcon-7aa905a9.js";
import { A as fe } from "./ChevronLeftIcon-b6affe9b.js";
import { M as pe } from "./MinusIcon-da08ac79.js";
import { T as he } from "./DownloadFileIcon-8a003268.js";
import { U as ge } from "./UserSingleIcon-e28f0f63.js";
import { B as ye } from "./ButtonSecondarySm-f6b60373.js";
import { C as K } from "./ChevronDownIcon-461d1eb9.js";
import { X as _e } from "./XIcon-e21df3cc.js";
import { TagMd as be } from "./tags.js";
import { D as xe } from "./DropdownTextDivider-98e5ec60.js";
import "./CheckIcon-91388c05.js";
import "./AlertTriangleIcon-d613f6a8.js";
import "./BadgeGraySm-db599b39.js";
import "./ButtonPlay-d3872713.js";
import "./BarProgressMd-c3ebb73b.js";
import "./ButtonCloseSm-209b27c6.js";
import "./PreloaderIcon-b44be854.js";
import "./_commonjsHelpers-10dfc225.js";
import "./MailIcon-b92e5b55.js";
import "./PhoneIcon-9b24c2d8.js";
const ve = {
  components: { MagnifyingGlassIcon: ee, CardShortcut: ne },
  props: {
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    shortcut: {
      type: String,
      default: ""
    }
  },
  emits: ["blur"]
}, Se = { "data-scroll": "" }, we = {
  for: "email",
  class: "block text-sm font-medium leading-6 ct-text-2"
}, ke = { class: "relative mt-2 rounded-lg shadow-sm shadow-gray-900/5" }, Ie = { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, Ve = ["placeholder", "disabled"], Fe = {
  key: 0,
  class: "absolute inset-y-0 right-0 flex items-center pr-3"
};
function Be(t, l, e, w, a, r) {
  const f = m("MagnifyingGlassIcon"), h = m("CardShortcut");
  return o(), i("div", Se, [
    s("label", we, g(e.label), 1),
    s("div", ke, [
      s("div", Ie, [
        k(f, { class: "w-5 h-5 ct-fg-4 mb-0.5" })
      ]),
      s("input", {
        id: "email",
        type: "email",
        name: "email",
        class: "ct-input ct-input--dropdown",
        placeholder: e.placeholder,
        disabled: e.disabled,
        onBlur: l[0] || (l[0] = (d) => t.$emit("blur", d))
      }, null, 40, Ve),
      e.shortcut ? (o(), i("div", Fe, [
        k(h, null, {
          default: y(() => [
            O(g(e.shortcut), 1)
          ]),
          _: 1
        })
      ])) : n("", !0)
    ])
  ]);
}
const Vr = /* @__PURE__ */ v(ve, [["render", Be]]), Ce = {
  name: "FormSwitch",
  components: {
    BadgePurpleSm: ie,
    ButtonPayment: de
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    slimMode: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:modelValue", t);
      }
    },
    activeIndex() {
      return this.options.findIndex((t) => t.value === this.model);
    },
    slideStyle() {
      if (this.activeIndex === -1)
        return { display: "none" };
      const t = this.slimMode ? 100 : 100 / this.options.length, l = this.slimMode ? 0 : this.activeIndex * (100 / this.options.length);
      return {
        width: `calc(${t}% - 8px)`,
        left: `${l}%`,
        transform: "translateX(4px)"
      };
    }
  },
  methods: {
    showBorder(t, l) {
      if (l === this.options.length - 1)
        return !1;
      const e = this.options[l + 1];
      return this.model !== t.value && this.model !== e.value;
    }
  }
}, Ee = { class: "absolute inset-0 p-1 pointer-events-none" }, Ne = ["onClick"], Me = { key: 0 }, He = {
  key: 2,
  class: "flex-shrink-0 flex items-center space-x-0.5"
};
function Te(t, l, e, w, a, r) {
  const f = m("ButtonPayment"), h = m("BadgePurpleSm");
  return o(), i("div", {
    class: x(["ct-switch relative", `grid-cols-${e.slimMode ? 1 : e.options.length}`])
  }, [
    s("div", Ee, [
      s("div", {
        class: "relative h-full rounded-lg border ct-border-1 ct-bg-1--alt shadow-sm shadow-gray-900/5 transition-all duration-200 ease-out",
        style: T(r.slideStyle)
      }, null, 4)
    ]),
    (o(!0), i(N, null, L(e.options, (d, p) => (o(), i("button", {
      key: d.value,
      type: "button",
      class: x(["relative w-full h-10 flex items-center justify-center px-4 space-x-2 text-sm font-medium transition-colors duration-200 z-10", [
        r.model === d.value ? "ct-text-1" : "ct-text-3",
        r.showBorder(d, p) ? "show-border" : ""
      ]]),
      onClick: (c) => r.model = d.value
    }, [
      d.label ? (o(), i("span", Me, g(d.label), 1)) : n("", !0),
      d.icon ? (o(), u(A(d.icon), {
        key: 1,
        class: "h-4.5"
      })) : n("", !0),
      d.icons ? (o(), i("div", He, [
        (o(!0), i(N, null, L(d.icons, (c) => (o(), i("div", {
          key: c,
          class: "flex items-center"
        }, [
          c === "GooglePayIcon" || c === "ApplePayIcon" ? (o(), u(f, { key: 0 }, {
            default: y(() => [
              (o(), u(A(c), { class: "w-5" }))
            ]),
            _: 2
          }, 1024)) : (o(), u(A(c), {
            key: 1,
            class: "w-6"
          }))
        ]))), 128))
      ])) : n("", !0),
      d.pro ? (o(), u(h, { key: 3 }, {
        default: y(() => l[0] || (l[0] = [
          O("Pro")
        ])),
        _: 1,
        __: [0]
      })) : n("", !0),
      d.badge ? (o(), u(h, { key: 4 }, {
        default: y(() => [
          O(g(d.badge), 1)
        ]),
        _: 2
      }, 1024)) : n("", !0)
    ], 10, Ne))), 128))
  ], 2);
}
const Fr = /* @__PURE__ */ v(Ce, [["render", Te]]), Oe = {
  name: "FormTextArea",
  components: {
    FormNotification: F,
    HelpIcon: V
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    rows: {
      type: Number,
      default: 3
    }
  },
  emits: ["update:modelValue", "blur"],
  setup(t) {
    return B(t);
  },
  data() {
    return {
      id: C()
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:modelValue", t);
      }
    }
  }
}, Ae = { "data-scroll": "" }, Le = ["for"], De = {
  key: 0,
  class: "ct-text-error"
}, Ue = { class: "relative mt-2 rounded-lg shadow-sm shadow-gray-900/5" }, qe = ["id", "placeholder", "disabled", "rows"];
function je(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("FormNotification"), d = I("tooltip");
  return o(), i("div", Ae, [
    s("label", {
      for: a.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
    }, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", De, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [d, { content: e.tooltip }]
      ]) : n("", !0)
    ], 8, Le),
    s("div", Ue, [
      _(s("textarea", {
        id: a.id,
        "onUpdate:modelValue": l[0] || (l[0] = (p) => r.model = p),
        class: x(["ct-input", { "is-error": t.hasError }]),
        placeholder: e.placeholder,
        disabled: e.disabled,
        rows: e.rows,
        onBlur: l[1] || (l[1] = (p) => t.$emit("blur", p))
      }, null, 42, qe), [
        [P, r.model]
      ])
    ]),
    t.hasHelp ? (o(), u(h, {
      key: 0,
      message: e.help,
      help: ""
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(h, {
      key: 1,
      message: e.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0)
  ]);
}
const Br = /* @__PURE__ */ v(Oe, [["render", je]]), Pe = {
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    noBorder: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasAsideSlot() {
      return !!this.$slots.aside;
    }
  }
}, Re = { class: "text-base font-medium ct-text-1" }, We = ["innerHTML"], $e = {
  key: 0,
  class: "grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6 md:col-span-2"
};
function Xe(t, l, e, w, a, r) {
  return o(), i("div", {
    class: x(["grid grid-cols-1 gap-x-8 gap-y-6 pb-12 md:grid-cols-3", [e.noBorder ? "" : "border-b ct-border-2"]])
  }, [
    s("div", {
      class: x([e.fullWidth ? "col-span-full" : ""])
    }, [
      s("h2", Re, g(e.title), 1),
      s("p", {
        class: "mt-1 text-sm ct-text-3",
        innerHTML: e.subtitle
      }, null, 8, We),
      b(t.$slots, "left")
    ], 2),
    r.hasAsideSlot ? (o(), i("div", $e, [
      b(t.$slots, "aside")
    ])) : n("", !0),
    b(t.$slots, "full")
  ], 2);
}
const Cr = /* @__PURE__ */ v(Pe, [["render", Xe]]), ze = {
  components: {
    FormNotification: F,
    AlertCircleIcon: M,
    HelpIcon: V
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    pattern: {
      type: String,
      default: ""
    }
  },
  emits: ["update:value", "update:prefix", "blur"],
  setup(t) {
    return B(t);
  },
  data() {
    return {
      id: C(),
      id2: C()
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(t) {
        D({ value: t, pattern: this.pattern }) && this.$emit(
          "update:value",
          U({ value: t, pattern: this.pattern, field: this.$refs.input })
        );
      }
    },
    prefixModel: {
      get() {
        return this.prefix;
      },
      set(t) {
        this.$emit("update:prefix", t);
      }
    }
  },
  mounted() {
    this.autofocus && this.$refs.input.focus();
  }
}, Ge = { "data-scroll": "" }, Ke = ["for"], Qe = {
  key: 0,
  class: "ct-text-error"
}, Je = { class: "relative mt-2 rounded-lg shadow-sm shadow-gray-900/5" }, Ye = { class: "absolute inset-y-0 left-0 flex items-center" }, Ze = ["for"], et = ["id"], tt = ["value"], ot = ["id", "type", "placeholder", "disabled"], lt = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
};
function rt(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("AlertCircleIcon"), d = m("FormNotification"), p = I("tooltip");
  return o(), i("div", Ge, [
    s("label", {
      for: a.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
    }, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", Qe, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [p, { content: e.tooltip }]
      ]) : n("", !0)
    ], 8, Ke),
    s("div", Je, [
      s("div", Ye, [
        s("label", {
          for: a.id2,
          class: "sr-only"
        }, g(e.title) + " prefix", 9, Ze),
        _(s("select", {
          id: a.id2,
          "onUpdate:modelValue": l[0] || (l[0] = (c) => r.prefixModel = c),
          autocomplete: "country",
          class: "bg-[right_0.25rem_center] h-full rounded-l-md border-0 bg-transparent py-0 pl-3 pr-6 ct-text-2 focus:outline-none focus:ring-inset focus:ring-2 focus:ct-ring-focus sm:text-sm"
        }, [
          (o(!0), i(N, null, L(e.options, (c) => (o(), i("option", {
            key: c.value,
            value: c.value
          }, g(c.label), 9, tt))), 128))
        ], 8, et), [
          [Q, r.prefixModel]
        ])
      ]),
      _(s("input", {
        id: a.id,
        ref: "input",
        "onUpdate:modelValue": l[1] || (l[1] = (c) => r.model = c),
        type: e.type,
        class: x(["ct-input ct-input--pre-dropdown", { "is-error": t.hasError }]),
        placeholder: e.placeholder,
        disabled: e.disabled,
        onBlur: l[2] || (l[2] = (c) => t.$emit("blur", c))
      }, null, 42, ot), [
        [E, r.model]
      ]),
      t.hasError ? (o(), i("div", lt, [
        k(h, {
          class: "h-4 w-4 text-error-500 dark:text-error-400",
          "aria-hidden": "true"
        })
      ])) : n("", !0)
    ]),
    t.hasHelp ? (o(), u(d, {
      key: 0,
      message: e.help,
      help: ""
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(d, {
      key: 1,
      message: e.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0)
  ]);
}
const Er = /* @__PURE__ */ v(ze, [["render", rt]]), st = {
  components: {
    AlertCircleIcon: M,
    HelpIcon: V,
    FormNotification: F
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    warning: {
      type: String,
      default: ""
    },
    success: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    textRight: {
      type: Boolean,
      default: !1
    },
    pattern: {
      type: String,
      default: ""
    },
    colors: { type: Object, default: () => ({}) }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(t) {
    return B(t);
  },
  data() {
    return {
      id: C()
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        D({ value: t, pattern: this.pattern }) && this.$emit(
          "update:modelValue",
          U({ value: t, pattern: this.pattern, field: this.$refs.input })
        );
      }
    }
  },
  mounted() {
    this.autofocus && this.$refs.input.focus();
  }
}, nt = { "data-scroll": "" }, it = ["for"], at = {
  key: 0,
  class: "ct-text-error"
}, dt = { class: "relative mt-2 rounded-lg shadow-sm shadow-gray-900/5" }, ut = { class: "flex-shrink-0 opacity-80" }, ct = ["id", "type", "placeholder", "disabled"], mt = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
};
function ft(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("AlertCircleIcon"), d = m("FormNotification"), p = I("tooltip");
  return o(), i("div", nt, [
    s("label", {
      for: a.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
    }, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", at, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [p, { content: e.tooltip }]
      ]) : n("", !0)
    ], 8, it),
    s("div", dt, [
      s("div", {
        class: x(["relative ct-input ct-input--pre-text space-x-0.5", { "is-error": e.error, "is-disabled": e.disabled }]),
        style: T({
          "background-color": e.colors.background,
          color: e.colors.text,
          "--tw-ring-color": e.colors.border
        })
      }, [
        s("p", ut, g(e.prefix), 1),
        _(s("input", {
          id: a.id,
          ref: "input",
          "onUpdate:modelValue": l[0] || (l[0] = (c) => r.model = c),
          type: e.type,
          class: x(["p-0 border-0 focus:ring-0 focus:outline-none bg-transparent w-full", {
            "is-error": t.hasError,
            "is-warning": t.hasWarning && !t.hasError,
            "is-success": t.hasSuccess && !t.hasError && !t.hasWarning,
            "text-right": e.textRight
          }]),
          placeholder: e.placeholder,
          disabled: e.disabled,
          onBlur: l[1] || (l[1] = (c) => t.$emit("blur", c)),
          onFocus: l[2] || (l[2] = (c) => t.$emit("focus", c))
        }, null, 42, ct), [
          [E, r.model]
        ]),
        e.error ? (o(), i("div", mt, [
          k(h, {
            class: "h-4 w-4 text-error-500 dark:text-error-400",
            "aria-hidden": "true"
          })
        ])) : n("", !0)
      ], 6)
    ]),
    t.hasHelp ? (o(), u(d, {
      key: 0,
      message: e.help,
      help: ""
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(d, {
      key: 1,
      message: e.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasWarning ? (o(), u(d, {
      key: 2,
      message: e.warning,
      "inner-classes": "mt-2 text-sm ct-text-warning"
    }, null, 8, ["message"])) : n("", !0),
    t.hasSuccess ? (o(), u(d, {
      key: 3,
      message: e.success,
      "inner-classes": "mt-2 text-sm ct-text-success"
    }, null, 8, ["message"])) : n("", !0)
  ]);
}
const Nr = /* @__PURE__ */ v(st, [["render", ft]]), pt = {
  components: {
    FormNotification: F,
    AlertCircleIcon: M,
    HelpIcon: V
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: "000000"
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "blur"],
  setup(t) {
    return B(t);
  },
  data() {
    return {
      id: C(),
      prefix: "#"
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue && this.modelValue.startsWith(this.prefix) ? this.modelValue.slice(this.prefix.length) : this.modelValue;
      },
      set(t) {
        if (!t) {
          this.$emit("update:modelValue", "");
          return;
        }
        t.startsWith(this.prefix) ? this.$emit("update:modelValue", t) : this.$emit("update:modelValue", this.prefix + t);
      }
    }
  },
  mounted() {
    this.autofocus && this.$refs.input.focus();
  }
}, ht = { "data-scroll": "" }, gt = ["for"], yt = {
  key: 0,
  class: "ct-text-error"
}, _t = { class: "relative mt-2 rounded-lg shadow-sm shadow-gray-900/5" }, bt = { class: "absolute inset-y-0 left-0 pl-3 flex items-center" }, xt = { class: "absolute inset-y-0 left-10 flex items-center ct-fg-3" }, vt = ["id", "type", "placeholder", "disabled"], St = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
};
function wt(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("AlertCircleIcon"), d = m("FormNotification"), p = I("tooltip");
  return o(), i("div", ht, [
    s("label", {
      for: a.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
    }, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", yt, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [p, { content: e.tooltip }]
      ]) : n("", !0)
    ], 8, gt),
    s("div", _t, [
      s("div", bt, [
        s("label", {
          style: T({ "background-color": e.modelValue }),
          class: "cursor-pointer h-5 w-5 border ct-border-1 rounded-md",
          "aria-hidden": "true"
        }, [
          _(s("input", {
            "onUpdate:modelValue": l[0] || (l[0] = (c) => r.model = c),
            type: "color",
            class: "invisible"
          }, null, 512), [
            [P, r.model]
          ])
        ], 4)
      ]),
      s("p", xt, g(a.prefix), 1),
      _(s("input", {
        id: a.id,
        ref: "input",
        "onUpdate:modelValue": l[1] || (l[1] = (c) => r.model = c),
        type: e.type,
        class: x(["ct-input ct-input--color", { "is-error": t.hasError }]),
        placeholder: e.placeholder,
        disabled: e.disabled,
        onBlur: l[2] || (l[2] = (c) => t.$emit("blur", c))
      }, null, 42, vt), [
        [E, r.model]
      ]),
      t.hasError ? (o(), i("div", St, [
        k(h, {
          class: "h-4 w-4 text-error-500 dark:text-error-400",
          "aria-hidden": "true"
        })
      ])) : n("", !0)
    ]),
    t.hasHelp ? (o(), u(d, {
      key: 0,
      message: e.help,
      help: ""
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(d, {
      key: 1,
      message: e.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0)
  ]);
}
const Mr = /* @__PURE__ */ v(pt, [["render", wt]]), kt = {
  components: { FormNotification: F },
  props: {
    modelValue: Boolean,
    title: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    disabled: Boolean
  },
  emits: ["update:modelValue"],
  setup(t) {
    return B(t);
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.disabled || this.$emit("update:modelValue", t);
      }
    }
  }
}, It = {
  key: 0,
  class: "flex-grow text-sm font-medium ct-text-2"
};
function Vt(t, l, e, w, a, r) {
  const f = m("FormNotification"), h = I("tooltip");
  return o(), i("div", null, [
    _((o(), i("div", {
      class: "flex items-center justify-between cursor-pointer space-x-1.5",
      onClick: l[0] || (l[0] = (d) => r.model = !r.model)
    }, [
      e.title ? (o(), i("p", It, g(e.title), 1)) : n("", !0),
      s("button", {
        type: "button",
        role: "switch",
        class: x(["relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none", {
          "cursor-not-allowed": e.disabled,
          "focus:ct-ring-focus--shadow": !e.disabled,
          "ct-bg-success--solid": r.model,
          "ct-bg-4": !r.model
        }])
      }, [
        s("span", {
          "aria-hidden": "true",
          class: x(["translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200", { "translate-x-5": r.model, "translate-x-0": !r.model }])
        }, null, 2)
      ], 2)
    ])), [
      [h, { content: e.tooltip, autoHide: !1, html: !0 }]
    ]),
    t.hasHelp ? (o(), u(f, {
      key: 0,
      message: e.help,
      help: "",
      "inner-classes": "mt-1 text-sm ct-text-3"
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(f, {
      key: 1,
      message: e.error,
      error: "",
      "inner-classes": "mt-1 text-sm ct-text-error"
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0)
  ]);
}
const Hr = /* @__PURE__ */ v(kt, [["render", Vt]]), Ft = {
  components: {
    FormNotification: F,
    AlertCircleIcon: M,
    HelpIcon: V,
    CopyDocumentIcon: ce
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    ctaIcon: {
      type: String,
      default: ""
    },
    ctaLabel: {
      type: String,
      default: ""
    },
    success: {
      type: String,
      default: ""
    },
    pattern: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "cta", "blur"],
  setup(t) {
    return B(t);
  },
  data() {
    return {
      id: C()
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        D({ value: t, pattern: this.pattern }) && this.$emit(
          "update:modelValue",
          U({ value: t, pattern: this.pattern, field: this.$refs.input })
        );
      }
    }
  },
  mounted() {
    this.autofocus && this.$refs.input.focus();
  }
}, Bt = { "data-scroll": "" }, Ct = ["for"], Et = {
  key: 0,
  class: "ct-text-error"
}, Nt = { class: "relative mt-2 flex items-center" }, Mt = { class: "w-full relative rounded-lg shadow-sm shadow-gray-900/5" }, Ht = ["id", "type", "placeholder", "disabled"], Tt = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
};
function Ot(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("AlertCircleIcon"), d = m("FormNotification"), p = I("tooltip");
  return o(), i("div", Bt, [
    s("label", {
      for: a.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
    }, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", Et, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [p, { content: e.tooltip }]
      ]) : n("", !0)
    ], 8, Ct),
    s("div", Nt, [
      s("div", Mt, [
        _(s("input", {
          id: a.id,
          ref: "input",
          "onUpdate:modelValue": l[0] || (l[0] = (c) => r.model = c),
          type: e.type,
          class: x(["ct-input", { "is-error": t.hasError, "ct-input--button": e.ctaLabel }]),
          placeholder: e.placeholder,
          disabled: e.disabled,
          onBlur: l[1] || (l[1] = (c) => t.$emit("blur", c))
        }, null, 42, Ht), [
          [E, r.model]
        ]),
        t.hasError ? (o(), i("div", Tt, [
          k(h, {
            class: "h-4 w-4 text-error-500 dark:text-error-400",
            "aria-hidden": "true"
          })
        ])) : n("", !0)
      ]),
      e.ctaLabel ? (o(), i("button", {
        key: 0,
        type: "button",
        class: "flex-shrink-0 -ml-px flex items-center space-x-1 rounded-r-lg bg-white dark:bg-neutral-900 hover:bg-gray-50 dark:hover:bg-neutral-800 border-0 ring-1 ring-inset ct-ring-1 shadow-sm shadow-gray-900/5 py-2.5 sm:py-3 px-3 sm:px-3.5 ct-text-2 text-sm font-medium",
        onClick: l[2] || (l[2] = (c) => t.$emit("cta"))
      }, [
        e.ctaIcon ? (o(), u(A(e.ctaIcon), {
          key: 0,
          class: "w-4.5 h-4.5"
        })) : n("", !0),
        s("span", null, g(e.ctaLabel), 1)
      ])) : n("", !0)
    ]),
    t.hasHelp ? (o(), u(d, {
      key: 0,
      message: e.help,
      help: ""
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(d, {
      key: 1,
      message: e.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasSuccess ? (o(), u(d, {
      key: 2,
      message: e.success,
      "inner-classes": "mt-2 text-sm ct-text-success"
    }, null, 8, ["message"])) : n("", !0)
  ]);
}
const Tr = /* @__PURE__ */ v(Ft, [["render", Ot]]), At = {
  components: {
    FormNotification: F,
    AlertCircleIcon: M,
    HelpIcon: V
  },
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    textRight: {
      type: Boolean,
      default: !1
    },
    option1Label: {
      type: [String, Object],
      default: ""
    },
    option2Label: {
      type: [String, Object],
      default: ""
    },
    option1: {
      type: [String, Number],
      default: ""
    },
    option2: {
      type: [String, Number],
      default: ""
    },
    patternOption1: {
      type: String,
      default: ""
    },
    patternOption2: {
      type: String,
      default: ""
    }
  },
  emits: ["update:option1", "update:option2", "blur"],
  setup(t) {
    return B(t);
  },
  data() {
    return {
      id: C(),
      selectedOption: this.option2 ? 2 : 1,
      option1Value: this.option1,
      option2Value: this.option2
    };
  },
  computed: {
    option1IsObject() {
      return typeof this.option1Label == "object";
    },
    option2IsObject() {
      return typeof this.option2Label == "object";
    },
    option1Selected() {
      return this.selectedOption === 1;
    },
    option2Selected() {
      return this.selectedOption === 2;
    },
    valueModel: {
      get() {
        return this.option1Selected ? this.option1Value : this.option2Value;
      },
      set(t) {
        let l;
        const e = this.option1Selected ? this.patternOption1 : this.patternOption2;
        D({ value: t, pattern: e }) ? (l = U({ value: t, pattern: e }), this.option1Selected ? this.$emit("update:option1", l) : this.$emit("update:option2", l)) : this.$refs.input.value = this.valueModel;
      }
    }
  },
  watch: {
    option1(t) {
      this.option1Value = t;
    },
    option2(t) {
      this.option2Value = t;
    }
  },
  mounted() {
    this.autofocus && this.$refs.input.focus();
  },
  methods: {
    selectOption1() {
      this.selectedOption = 1, this.option2Value = "", this.updateOptions();
    },
    selectOption2() {
      this.selectedOption = 2, this.option1Value = "", this.updateOptions();
    },
    updateOptions() {
      this.$emit("update:option1", this.option1Value), this.$emit("update:option2", this.option2Value);
    }
  }
}, Lt = { "data-scroll": "" }, Dt = ["for"], Ut = {
  key: 0,
  class: "ct-text-error"
}, qt = { class: "mt-2 w-full relative rounded-lg shadow-sm shadow-gray-900/5" }, jt = { class: "flex-shrink-0 p-px group-focus-within:p-0.5" }, Pt = { class: "ct-switch ct-switch--input grid-cols-2" }, Rt = ["disabled"], Wt = { key: 1 }, $t = ["disabled"], Xt = { key: 1 }, zt = ["id", "type", "placeholder", "disabled"], Gt = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
};
function Kt(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("AlertCircleIcon"), d = m("FormNotification"), p = I("tooltip");
  return o(), i("div", Lt, [
    s("label", {
      for: a.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
    }, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", Ut, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [p, { content: e.tooltip }]
      ]) : n("", !0)
    ], 8, Dt),
    s("div", qt, [
      s("div", {
        class: x(["group relative ct-input ct-input--switch", { "is-error": t.hasError, "is-disabled": e.disabled }])
      }, [
        s("div", jt, [
          s("div", Pt, [
            s("button", {
              type: "button",
              class: x(["w-10 py-2 rounded text-xs font-medium group-focus-within:py-[7px] flex items-center justify-center", [
                r.option1Selected ? "border ct-border-1 ct-bg-1--alt shadow-sm shadow-gray-900/5 ct-text-1" : "ct-text-3"
              ]]),
              disabled: e.disabled,
              onClick: l[0] || (l[0] = (...c) => r.selectOption1 && r.selectOption1(...c))
            }, [
              r.option1IsObject ? (o(), u(A(e.option1Label), {
                key: 0,
                class: "w-3.5 h-3.5"
              })) : (o(), i("span", Wt, g(e.option1Label), 1))
            ], 10, Rt),
            s("button", {
              type: "button",
              class: x(["w-10 py-2 rounded text-xs font-medium group-focus-within:py-[7px] flex items-center justify-center", [
                r.option2Selected ? "border ct-border-1 ct-bg-1--alt shadow-sm shadow-gray-900/5 ct-text-1" : "ct-text-3"
              ]]),
              disabled: e.disabled,
              onClick: l[1] || (l[1] = (...c) => r.selectOption2 && r.selectOption2(...c))
            }, [
              r.option2IsObject ? (o(), u(A(e.option2Label), {
                key: 0,
                class: "w-3.5 h-3.5"
              })) : (o(), i("span", Xt, g(e.option2Label), 1))
            ], 10, $t)
          ])
        ]),
        _(s("input", {
          id: a.id,
          ref: "input",
          "onUpdate:modelValue": l[2] || (l[2] = (c) => r.valueModel = c),
          type: e.type,
          class: x(["p-0 border-0 focus:ring-0 focus:outline-none bg-transparent w-full py-2 sm:py-2.5 px-3 sm:px-3.5", { "is-error": t.hasError, "text-right": e.textRight }]),
          placeholder: e.placeholder,
          disabled: e.disabled,
          onBlur: l[3] || (l[3] = (c) => t.$emit("blur", c))
        }, null, 42, zt), [
          [E, r.valueModel]
        ]),
        t.hasError ? (o(), i("div", Gt, [
          k(h, {
            class: "h-4 w-4 text-error-500 dark:text-error-400",
            "aria-hidden": "true"
          })
        ])) : n("", !0)
      ], 2)
    ]),
    t.hasHelp ? (o(), u(d, {
      key: 0,
      message: e.help,
      help: ""
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(d, {
      key: 1,
      message: e.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0)
  ]);
}
const Or = /* @__PURE__ */ v(At, [["render", Kt]]), Qt = {
  name: "FormVariant",
  components: { FormNotification: F, BadgeSuccessSm: ae },
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    variant: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:modelValue"],
  setup(t) {
    return B(t);
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:modelValue", t);
      }
    }
  }
}, Jt = { class: "relative" }, Yt = ["value", "disabled"], Zt = { class: "ml-2 text-sm" }, eo = ["innerHTML"], to = ["innerHTML"];
function oo(t, l, e, w, a, r) {
  const f = m("BadgeSuccessSm"), h = m("FormNotification"), d = I("tooltip");
  return _((o(), i("div", Jt, [
    e.variant.badge ? (o(), u(f, {
      key: 0,
      class: "absolute top-3 left-3"
    }, {
      default: y(() => [
        O(g(e.variant.badge), 1)
      ]),
      _: 1
    })) : n("", !0),
    s("label", {
      class: x(["cursor-pointer flex items-start w-full rounded-lg ct-bg-1--alt border-0 ring-inset focus-wihin:ring-inset p-3 shadow-gray-900/5", [
        { "ring-1 opacity-40 pointer-events-none": e.variant.disabled },
        { "pt-10": e.variant.badge },
        e.variant.error ? "ring-1 ct-ring-error focus:ct-ring-error-focus--shadow ct-text-error" : e.modelValue === e.variant.value ? "ring-2 ct-ring-brand focus-within:ct-ring-focus" : "ring-1 ct-ring-1 hover:ct-ring-brand "
      ]])
    }, [
      _(s("input", {
        "onUpdate:modelValue": l[0] || (l[0] = (p) => r.model = p),
        value: e.variant.value,
        type: "radio",
        class: "mt-0.5 h-4 w-4 ct-text-1 outline-none ring-0 border ct-border-1 rounded-full bg-transparent focus:outline-none focus:ring-0 enabled:cursor-pointer shadow-none focus:shadow-none focus:ring-offset-0",
        disabled: e.variant.disabled
      }, null, 8, Yt), [
        [J, r.model]
      ]),
      s("div", Zt, [
        e.variant.label ? (o(), i("p", {
          key: 0,
          class: "font-medium ct-text-2",
          innerHTML: e.variant.label
        }, null, 8, eo)) : n("", !0),
        e.variant.info ? (o(), i("p", {
          key: 1,
          class: "ct-text-3",
          innerHTML: e.variant.info
        }, null, 8, to)) : n("", !0)
      ])
    ], 2),
    t.hasError ? (o(), u(h, {
      key: 1,
      message: e.variant.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0)
  ])), [
    [d, e.variant.tooltip]
  ]);
}
const lo = /* @__PURE__ */ v(Qt, [["render", oo]]), ro = {
  components: {
    HelpIcon: V,
    FormVariant: lo
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    required: Boolean,
    variants: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:modelValue", t);
      }
    }
  }
}, so = { "data-scroll": "" }, no = { class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1" }, io = {
  key: 0,
  class: "ct-text-error"
}, ao = { class: "mt-2 space-y-3" };
function uo(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("FormVariant"), d = I("tooltip");
  return o(), i("div", so, [
    s("label", no, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", io, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [d, { content: e.tooltip }]
      ]) : n("", !0)
    ]),
    s("div", ao, [
      (o(!0), i(N, null, L(e.variants, (p) => (o(), u(h, {
        key: p.value,
        modelValue: r.model,
        "onUpdate:modelValue": l[0] || (l[0] = (c) => r.model = c),
        variant: p
      }, null, 8, ["modelValue", "variant"]))), 128))
    ])
  ]);
}
const Ar = /* @__PURE__ */ v(ro, [["render", uo]]), co = {
  name: "FormLabel",
  components: {
    HelpIcon: V
  },
  props: {
    tooltip: {
      type: String,
      default: ""
    },
    required: Boolean
  }
}, mo = { class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1" }, fo = {
  key: 0,
  class: "ct-text-error"
};
function po(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = I("tooltip");
  return o(), i("label", mo, [
    b(t.$slots, "default"),
    e.required ? (o(), i("span", fo, "*")) : n("", !0),
    e.tooltip ? _((o(), u(f, {
      key: 1,
      class: "cursor-pointer ct-fg-4 h-4 w-4"
    }, null, 512)), [
      [h, { content: e.tooltip }]
    ]) : n("", !0)
  ]);
}
const Lr = /* @__PURE__ */ v(co, [["render", po]]), ho = {
  components: {
    FormNotification: F,
    AlertCircleIcon: M,
    HelpIcon: V
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    textRight: {
      type: Boolean,
      default: !1
    },
    pattern: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "blur"],
  setup(t) {
    return B(t);
  },
  data() {
    return {
      id: C()
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        D({ value: t, pattern: this.pattern }) && this.$emit(
          "update:modelValue",
          U({ value: t, pattern: this.pattern, field: this.$refs.input })
        );
      }
    }
  },
  mounted() {
    this.autofocus && this.$refs.input.focus();
  }
}, go = { "data-scroll": "" }, yo = ["for"], _o = {
  key: 0,
  class: "ct-text-error"
}, bo = { class: "mt-2 w-full relative rounded-lg shadow-sm shadow-gray-900/5" }, xo = ["id", "type", "placeholder", "disabled"], vo = { class: "ct-fg-3" }, So = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
};
function wo(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("AlertCircleIcon"), d = m("FormNotification"), p = I("tooltip");
  return o(), i("div", go, [
    s("label", {
      for: a.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
    }, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", _o, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [p, { content: e.tooltip }]
      ]) : n("", !0)
    ], 8, yo),
    s("div", bo, [
      s("div", {
        class: x(["relative ct-input ct-input--pre-text ct-input--post-text space-x-2", { "is-error": t.hasError, "is-disabled": e.disabled }])
      }, [
        _(s("input", {
          id: a.id,
          ref: "input",
          "onUpdate:modelValue": l[0] || (l[0] = (c) => r.model = c),
          type: e.type,
          class: x(["p-0 border-0 focus:ring-0 focus:outline-none bg-transparent w-full", { "is-error": t.hasError, "text-right": e.textRight }]),
          placeholder: e.placeholder,
          disabled: e.disabled,
          onBlur: l[1] || (l[1] = (c) => t.$emit("blur", c))
        }, null, 42, xo), [
          [E, r.model]
        ]),
        s("p", vo, g(e.suffix), 1),
        t.hasError ? (o(), i("div", So, [
          k(h, {
            class: "h-4 w-4 text-error-500 dark:text-error-400",
            "aria-hidden": "true"
          })
        ])) : n("", !0)
      ], 2)
    ]),
    t.hasHelp ? (o(), u(d, {
      key: 0,
      message: e.help,
      help: ""
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(d, {
      key: 1,
      message: e.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0)
  ]);
}
const Dr = /* @__PURE__ */ v(ho, [["render", wo]]), ko = {
  components: {
    FormNotification: F,
    HelpIcon: V
  },
  props: {
    top: {
      type: [String, Number],
      default: ""
    },
    bottom: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholderTop: {
      type: String,
      default: ""
    },
    placeholderBottom: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    }
  },
  emits: ["update:top", "update:bottom", "blur"],
  setup(t) {
    return B(t);
  },
  data() {
    return {
      id: C()
    };
  },
  computed: {
    topModel: {
      get() {
        return this.top;
      },
      set(t) {
        this.$emit("update:top", t);
      }
    },
    bottomModel: {
      get() {
        return this.bottom;
      },
      set(t) {
        this.$emit("update:bottom", t);
      }
    }
  },
  mounted() {
    this.autofocus && this.$refs.input.focus();
  }
}, Io = { "data-scroll": "" }, Vo = ["for"], Fo = {
  key: 0,
  class: "ct-text-error"
}, Bo = ["id", "type", "placeholder", "disabled"], Co = ["id", "type", "placeholder", "disabled"];
function Eo(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("FormNotification"), d = I("tooltip");
  return o(), i("div", Io, [
    s("label", {
      for: a.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
    }, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", Fo, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [d, { content: e.tooltip }]
      ]) : n("", !0)
    ], 8, Vo),
    s("div", {
      class: x(["relative mt-2 rounded-lg shadow-sm shadow-gray-900/5 ct-input--double", { "is-error": t.hasError }])
    }, [
      _(s("input", {
        id: a.id,
        ref: "input",
        "onUpdate:modelValue": l[0] || (l[0] = (p) => r.topModel = p),
        type: e.type,
        class: x(["ct-input", { "is-error": t.hasError }]),
        placeholder: e.placeholderTop,
        disabled: e.disabled,
        onBlur: l[1] || (l[1] = (p) => t.$emit("blur", p))
      }, null, 42, Bo), [
        [E, r.topModel]
      ]),
      _(s("input", {
        id: a.id,
        ref: "input",
        "onUpdate:modelValue": l[2] || (l[2] = (p) => r.bottomModel = p),
        type: e.type,
        class: x(["ct-input", { "is-error": t.hasError }]),
        placeholder: e.placeholderBottom,
        disabled: e.disabled,
        onBlur: l[3] || (l[3] = (p) => t.$emit("blur", p))
      }, null, 42, Co), [
        [E, r.bottomModel]
      ])
    ], 2),
    t.hasHelp ? (o(), u(h, {
      key: 0,
      message: e.help,
      help: ""
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(h, {
      key: 1,
      message: e.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0)
  ]);
}
const Ur = /* @__PURE__ */ v(ko, [["render", Eo]]), No = {
  name: "FormInputQuantity",
  components: {
    MinusIcon: pe,
    AddIcon: fe
  },
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    minValue: {
      type: Number,
      default: null
    },
    maxValue: {
      type: Number,
      default: null
    },
    colors: { type: Object, default: () => ({}) }
  },
  emits: ["update:modelValue", "blur"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.minValue !== null && t < this.minValue && (t = this.minValue), this.maxValue !== null && t > this.maxValue && (t = this.maxValue), this.$emit("update:modelValue", +t);
      }
    }
  }
}, Mo = {
  "data-scroll": "",
  class: "relative rounded-lg shadow-md shadow-gray-900/5"
}, Ho = ["disabled"], To = ["disabled"];
function Oo(t, l, e, w, a, r) {
  const f = m("MinusIcon"), h = m("AddIcon");
  return o(), i("div", Mo, [
    s("div", {
      class: "ct-input--quantity flex items-center",
      style: T({ "--tw-ring-color": e.colors.border })
    }, [
      s("button", {
        disabled: e.minValue !== null && r.model <= e.minValue,
        style: T({
          "background-color": e.colors.background,
          color: e.colors.text
        }),
        onClick: l[0] || (l[0] = (d) => r.model--)
      }, [
        k(f, { class: "w-4.5 h-4.5" })
      ], 12, Ho),
      _(s("input", {
        "onUpdate:modelValue": l[1] || (l[1] = (d) => r.model = d),
        type: "text",
        class: "ct-input",
        style: T({
          "background-color": e.colors.background,
          color: e.colors.text,
          "border-color": e.colors.border
        }),
        onBlur: l[2] || (l[2] = (d) => t.$emit("blur", d))
      }, null, 36), [
        [P, r.model]
      ]),
      s("button", {
        disabled: e.maxValue !== null && r.model >= e.maxValue,
        style: T({
          "background-color": e.colors.background,
          color: e.colors.text
        }),
        onClick: l[3] || (l[3] = (d) => r.model++)
      }, [
        k(h, { class: "w-4.5 h-4.5" })
      ], 12, To)
    ], 4)
  ]);
}
const qr = /* @__PURE__ */ v(No, [["render", Oo]]), Ao = {}, Lo = { class: "w-full border-b ct-border-2" };
function Do(t, l) {
  return o(), i("div", Lo);
}
const jr = /* @__PURE__ */ v(Ao, [["render", Do]]), Uo = {
  name: "FormVariantCheck",
  props: {
    modelValue: Boolean,
    label: {
      type: String,
      default: ""
    },
    info: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:modelValue", t);
      }
    }
  }
}, qo = { class: "relative" }, jo = ["value", "disabled"], Po = { class: "ml-2 text-sm" };
function Ro(t, l, e, w, a, r) {
  return o(), i("div", qo, [
    s("label", {
      class: x(["cursor-pointer flex items-start w-full rounded-lg ct-bg-1--alt border-0 ring-inset focus-wihin:ring-inset p-3 shadow-gray-900/5", [
        { "ring-1 opacity-40 pointer-events-none": e.disabled },
        e.error ? "ring-1 ct-ring-error focus:ct-ring-error-focus--shadow ct-text-error" : r.model ? "ring-2 ct-ring-brand focus-within:ct-ring-focus" : "ring-1 ct-ring-1 hover:ct-ring-brand "
      ]])
    }, [
      _(s("input", {
        "onUpdate:modelValue": l[0] || (l[0] = (f) => r.model = f),
        value: e.modelValue,
        type: "checkbox",
        class: "mt-0.5 h-4 w-4 ct-text-1 outline-none ring-0 border ct-border-1 rounded bg-transparent focus:outline-none focus:ring-0 enabled:cursor-pointer shadow-none focus:shadow-none focus:ring-offset-0",
        disabled: e.disabled
      }, null, 8, jo), [
        [Y, r.model]
      ]),
      s("div", Po, [
        b(t.$slots, "default")
      ])
    ], 2),
    e.error ? (o(), i("p", {
      key: 0,
      class: x(["mt-2 text-sm", [e.error ? "ct-text-error" : "ct-text-3"]])
    }, g(e.error), 3)) : n("", !0)
  ]);
}
const Pr = /* @__PURE__ */ v(Uo, [["render", Ro]]), Wo = {}, $o = { class: "py-2 border-b ct-border-2 text-base font-medium ct-text-1" };
function Xo(t, l) {
  return o(), i("div", $o, [
    b(t.$slots, "default")
  ]);
}
const Rr = /* @__PURE__ */ v(Wo, [["render", Xo]]), zo = {
  components: {
    FormNotification: F,
    AlertCircleIcon: M,
    HelpIcon: V
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    textRight: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "blur"],
  setup(t) {
    return B(t);
  },
  data() {
    return {
      id: C(),
      prefix: "https://"
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue && this.modelValue.startsWith(this.prefix) ? this.modelValue.slice(this.prefix.length) : this.modelValue;
      },
      set(t) {
        if (!t) {
          this.$emit("update:modelValue", "");
          return;
        }
        t.startsWith(this.prefix) ? this.$emit("update:modelValue", t) : this.$emit("update:modelValue", this.prefix + t);
      }
    }
  },
  mounted() {
    this.autofocus && this.$refs.input.focus();
  }
}, Go = { "data-scroll": "" }, Ko = ["for"], Qo = {
  key: 0,
  class: "ct-text-error"
}, Jo = { class: "w-full relative mt-2 rounded-lg shadow-sm shadow-gray-900/5" }, Yo = { class: "ct-fg-3" }, Zo = ["id", "type", "placeholder", "disabled"], el = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
};
function tl(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("AlertCircleIcon"), d = m("FormNotification"), p = I("tooltip");
  return o(), i("div", Go, [
    s("label", {
      for: a.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
    }, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", Qo, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [p, { content: e.tooltip }]
      ]) : n("", !0)
    ], 8, Ko),
    s("div", Jo, [
      s("div", {
        class: x(["relative ct-input ct-input--pre-text space-x-2", { "is-error": t.hasError, "is-disabled": e.disabled }])
      }, [
        s("p", Yo, g(a.prefix), 1),
        _(s("input", {
          id: a.id,
          ref: "input",
          "onUpdate:modelValue": l[0] || (l[0] = (c) => r.model = c),
          type: e.type,
          class: x(["p-0 border-0 focus:ring-0 focus:outline-none bg-transparent w-full", {
            "is-error": t.hasError,
            "is-warning": t.hasWarning && !t.hasError,
            "is-success": t.hasSuccess && !t.hasError && !t.hasWarning,
            "text-right": e.textRight
          }]),
          placeholder: e.placeholder,
          disabled: e.disabled,
          onBlur: l[1] || (l[1] = (c) => t.$emit("blur", c))
        }, null, 42, Zo), [
          [E, r.model]
        ]),
        t.hasError ? (o(), i("div", el, [
          k(h, {
            class: "h-4 w-4 text-error-500 dark:text-error-400",
            "aria-hidden": "true"
          })
        ])) : n("", !0)
      ], 2)
    ]),
    t.hasHelp ? (o(), u(d, {
      key: 0,
      message: e.help,
      help: ""
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(d, {
      key: 1,
      message: e.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0)
  ]);
}
const Wr = /* @__PURE__ */ v(zo, [["render", tl]]), X = {
  crop: "Crop avatar",
  discard: "Cancel upload"
}, ol = {
  name: "FormAvatar",
  components: {
    FormFilesCropper: te,
    ButtonSecondarySm: ye,
    UploadBox2Icon: me,
    TrashBinIcon: he,
    UserSingleIcon: ge,
    HelpIcon: V
  },
  props: {
    file: {
      type: String,
      default: ""
    },
    uploadLabel: {
      type: String,
      default: "Upload"
    },
    deleteLabel: {
      type: String,
      default: "Delete"
    },
    disabled: Boolean,
    acceptTypes: {
      type: String,
      default: "image/*"
    },
    title: {
      type: String,
      default: ""
    },
    required: Boolean,
    tooltip: {
      type: String,
      default: ""
    },
    cropperConfig: {
      type: Object,
      default: () => ({
        ...z.AVATAR(),
        hidden: !0
        // this prop is only to not show cropper by default
      })
    },
    cropperLabels: {
      type: Object,
      default: () => ({ ...X })
    }
  },
  emits: ["loadFile"],
  data() {
    return {
      id: C(),
      dragged: !1,
      fileToCrop: null
    };
  },
  computed: {
    useCropper() {
      var t;
      return this.cropperConfig === null ? !1 : ((t = this.cropperConfig) == null ? void 0 : t.hidden) !== !0;
    },
    cropperLabelsWithDefaults() {
      return { ...X, ...this.cropperLabels };
    }
  },
  methods: {
    changeFile({ target: t }) {
      const [l] = t.files;
      this.useCropper ? this.fileToCrop = l : this.$emit("loadFile", l), t.value = null;
    },
    drop({ dataTransfer: t }) {
      if (this.disabled)
        return;
      const { fileInput: l } = this.$refs;
      l.files = t.files, this.changeFile({ target: l }), this.dragged = !1;
    },
    deleteFile() {
      this.$emit("loadFile", null);
    },
    fileCropped(t) {
      this.$emit("loadFile", t);
    }
  }
}, ll = { class: "space-y-2" }, rl = {
  key: 0,
  class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
}, sl = {
  key: 0,
  class: "ct-text-error"
}, nl = { class: "flex items-center space-x-4" }, il = ["for", "disabled"], al = ["src"], dl = { class: "flex space-x-2" }, ul = ["for"], cl = ["id", "disabled", "accept"];
function ml(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("UserSingleIcon"), d = m("UploadBox2Icon"), p = m("TrashBinIcon"), c = m("ButtonSecondarySm"), R = m("FormFilesCropper"), W = I("tooltip");
  return o(), i("div", ll, [
    e.title ? (o(), i("p", rl, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", sl, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [W, { content: e.tooltip }]
      ]) : n("", !0)
    ])) : n("", !0),
    s("div", nl, [
      s("div", null, [
        e.file ? (o(), i("img", {
          key: 1,
          class: "w-16 h-16 rounded-full object-cover mr-4",
          src: e.file,
          alt: "avatar"
        }, null, 8, al)) : (o(), i("label", {
          key: 0,
          for: a.id,
          disabled: e.disabled,
          class: x(["ct-bg-3 h-16 w-16 rounded-full flex items-center justify-center text-gray-500 dark:text-neutral-200", [
            a.dragged && !e.disabled ? " border-2 border-dashed ct-border-2" : "",
            e.disabled ? "opacity-50 cursor-default" : "cursor-pointer "
          ]]),
          onDragover: l[0] || (l[0] = $((H) => a.dragged = !0, ["prevent"])),
          onDragleave: l[1] || (l[1] = (H) => a.dragged = !1),
          onDrop: l[2] || (l[2] = $((...H) => r.drop && r.drop(...H), ["prevent"]))
        }, [
          k(h, { class: "h-6 w-6" })
        ], 42, il))
      ]),
      s("div", dl, [
        s("label", {
          for: a.id,
          class: x(["ct-btn-sm border", [
            e.disabled ? "ct-fg-disabled border-gray-200 dark:border-neutral-800" : "bg-white dark:bg-neutral-900 hover:bg-gray-50 dark:hover:bg-neutral-800 text-gray-700 dark:text-neutral-300 hover:text-gray-800 dark:hover:text-neutral-100 border-gray-300 dark:border-neutral-700 cursor-pointer"
          ]])
        }, [
          k(d),
          s("span", null, g(e.uploadLabel), 1)
        ], 10, ul),
        s("input", {
          id: a.id,
          ref: "fileInput",
          type: "file",
          class: "sr-only",
          disabled: e.disabled,
          accept: e.acceptTypes,
          onChange: l[3] || (l[3] = (...H) => r.changeFile && r.changeFile(...H))
        }, null, 40, cl),
        e.file && !e.disabled ? (o(), u(c, {
          key: 0,
          onClick: r.deleteFile
        }, {
          default: y(() => [
            k(p),
            s("span", null, g(e.deleteLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : n("", !0)
      ])
    ]),
    k(R, {
      "file-to-crop": a.fileToCrop,
      config: e.cropperConfig,
      "crop-label": r.cropperLabelsWithDefaults.crop,
      "discard-label": r.cropperLabelsWithDefaults.discard,
      onCropped: r.fileCropped
    }, null, 8, ["file-to-crop", "config", "crop-label", "discard-label", "onCropped"])
  ]);
}
const $r = /* @__PURE__ */ v(ol, [["render", ml]]), fl = {
  props: {
    title: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    }
  }
}, pl = { class: "space-y-1" }, hl = { class: "text-base font-medium ct-text-1" }, gl = {
  key: 0,
  class: "ct-text"
};
function yl(t, l, e, w, a, r) {
  return o(), i("div", pl, [
    s("p", hl, g(e.title), 1),
    e.help ? (o(), i("p", gl, g(e.help), 1)) : n("", !0)
  ]);
}
const Xr = /* @__PURE__ */ v(fl, [["render", yl]]), _l = {
  components: {
    FormNotification: F,
    AlertCircleIcon: M,
    ChevronDownIcon: K,
    HelpIcon: V
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    focused: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    success: {
      type: String,
      default: ""
    },
    warning: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    isSelect: {
      type: Boolean,
      default: !1
    },
    inputClasses: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return B(t);
  }
}, bl = { "data-scroll": "" }, xl = {
  key: 0,
  class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1 mb-2"
}, vl = {
  key: 0,
  class: "ct-text-error"
}, Sl = { class: "relative rounded-lg shadow-sm shadow-gray-900/5" }, wl = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
}, kl = {
  key: 1,
  class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
};
function Il(t, l, e, w, a, r) {
  const f = m("HelpIcon"), h = m("AlertCircleIcon"), d = m("ChevronDownIcon"), p = m("FormNotification"), c = I("tooltip");
  return o(), i("div", bl, [
    e.title ? (o(), i("label", xl, [
      s("span", null, g(e.title), 1),
      e.required ? (o(), i("span", vl, "*")) : n("", !0),
      e.tooltip ? _((o(), u(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [c, { content: e.tooltip }]
      ]) : n("", !0)
    ])) : n("", !0),
    s("div", Sl, [
      s("div", {
        class: x(["relative ct-input--container", [
          {
            "ct-input": !e.isSelect,
            "ct-input--select": e.isSelect,
            "is-error": t.showErrorClass,
            "is-disabled": e.disabled,
            "is-focused": !t.hasError && e.focused,
            "is-error-focused": t.hasError && e.focused
          },
          e.inputClasses
        ]])
      }, [
        b(t.$slots, "default")
      ], 2),
      !e.isSelect && t.showErrorClass ? (o(), i("div", wl, [
        t.showErrorClass ? (o(), u(h, {
          key: 0,
          class: "h-4 w-4 text-error-500 dark:text-error-400",
          "aria-hidden": "true"
        })) : n("", !0)
      ])) : n("", !0),
      e.isSelect ? (o(), i("span", kl, [
        k(d, {
          class: x(["h-5 w-5 transform transition-transform", {
            "text-gray-400": !t.showErrorClass,
            "text-red-300": t.showErrorClass,
            "rotate-180": e.focused
          }])
        }, null, 8, ["class"])
      ])) : n("", !0)
    ]),
    t.hasHelp ? (o(), u(p, {
      key: 1,
      message: e.help,
      help: ""
    }, {
      default: y(() => [
        b(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (o(), u(p, {
      key: 2,
      message: e.error,
      error: ""
    }, {
      default: y(() => [
        b(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasWarning ? (o(), u(p, {
      key: 3,
      message: e.warning,
      "inner-classes": "mt-2 text-sm ct-text-warning"
    }, null, 8, ["message"])) : n("", !0),
    t.hasSuccess ? (o(), u(p, {
      key: 4,
      message: e.success,
      "inner-classes": "mt-2 text-sm ct-text-success"
    }, null, 8, ["message"])) : n("", !0)
  ]);
}
const zr = /* @__PURE__ */ v(_l, [["render", Il]]), Vl = {
  components: {
    ChevronDownIcon: K,
    HelpIcon: V,
    SelectOption: ue,
    TagMd: be,
    XIcon: _e,
    DropdownTextDivider: xe
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    values: {
      type: Array,
      default: () => []
    },
    disabled: Boolean,
    isInvalid: Boolean,
    transparent: Boolean,
    searchEnabled: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["input", "change"],
  data() {
    return {
      selfValue: this.values,
      expanded: !1,
      search: "",
      selectedIndex: 0
    };
  },
  computed: {
    selectedOptions() {
      if (this.values === void 0)
        return null;
      const t = this.options.filter((l) => this.values.includes(l.value));
      return t.length ? t : null;
    },
    availableOptions() {
      return this.search ? this.options.filter(
        (t) => !t.isDivider && t.label.toLowerCase().includes(this.search.toLowerCase())
      ) : this.options;
    }
  },
  watch: {
    expanded(t) {
      t && this.searchEnabled ? this.$nextTick(() => {
        this.$refs.searchInput.focus();
      }) : this.search = "";
    },
    availableOptions() {
      this.selectedIndex = 0;
    }
  },
  methods: {
    hide(t) {
      t && t.stopImmediatePropagation(), this.expanded = !1;
    },
    show() {
      this.disabled || (this.expanded = !0);
    },
    select(t) {
      this.$emit("input", t), this.$emit("change", t), this.hide();
    },
    selectCurrentOption() {
      const t = this.availableOptions[this.selectedIndex];
      this.select(t ? t.value : null);
    },
    moveIndexUp() {
      this.selectedIndex = Math.max(this.selectedIndex - 1, 0), this.scrollList();
    },
    moveIndexDown() {
      this.selectedIndex = Math.min(this.selectedIndex + 1, this.availableOptions.length - 1), this.scrollList();
    },
    scrollList() {
      const t = this.$refs[`option-${this.selectedIndex}`];
      t[0] && t[0].$el.scrollIntoView({
        block: "nearest"
      });
    }
  }
}, Fl = { class: "flex items-center relative" }, Bl = {
  key: 0,
  class: "mr-2 text-sm font-medium ct-text-1"
}, Cl = { class: "w-full relative rounded-lg shadow-sm shadow-gray-900/5" }, El = {
  key: 0,
  class: "block truncate space-x-1"
}, Nl = ["placeholder"], Ml = { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }, Hl = {
  key: 2,
  class: "absolute inset-y-0 right-4 pr-3 flex items-center"
}, Tl = {
  key: 0,
  ref: "list",
  class: "ct-bg-1--alt absolute top-full z-10 mt-1 w-full shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
};
function Ol(t, l, e, w, a, r) {
  const f = m("XIcon"), h = m("TagMd"), d = m("ChevronDownIcon"), p = m("HelpIcon"), c = m("DropdownTextDivider"), R = m("SelectOption"), W = I("tooltip"), H = I("click-outside");
  return o(), i("div", Fl, [
    e.label ? (o(), i("label", Bl, g(e.label), 1)) : n("", !0),
    s("div", Cl, [
      s("div", {
        class: x(["ct-input--select", {
          "is-disabled": e.disabled,
          "is-error": e.isInvalid
        }]),
        onClick: l[5] || (l[5] = (...S) => r.show && r.show(...S))
      }, [
        !e.searchEnabled || !a.expanded ? (o(), i("p", El, [
          r.selectedOptions ? (o(!0), i(N, { key: 0 }, L(r.selectedOptions, (S) => (o(), u(h, {
            key: S.value,
            onClick: $((q) => r.select(S.value), ["stop"])
          }, {
            default: y(() => [
              O(g(S.shortLabel ? S.shortLabel : S.label) + " ", 1),
              k(f, { class: "h-2 w-2 ct-fg-4 inline ml-0.5 mb-0.5" })
            ]),
            _: 2
          }, 1032, ["onClick"]))), 128)) : (o(), i(N, { key: 1 }, [
            O(g(e.title || "Select"), 1)
          ], 64))
        ])) : n("", !0),
        a.expanded && e.searchEnabled ? _((o(), i("input", {
          key: 1,
          ref: "searchInput",
          "onUpdate:modelValue": l[0] || (l[0] = (S) => a.search = S),
          class: "block w-full border-0 p-0 ct-text-1 placeholder:ct-text-placeholder focus:ring-0 text-base bg-transparent",
          type: "text",
          placeholder: e.placeholder,
          onKeydown: [
            l[1] || (l[1] = j((...S) => r.moveIndexUp && r.moveIndexUp(...S), ["up"])),
            l[2] || (l[2] = j((...S) => r.moveIndexDown && r.moveIndexDown(...S), ["down"]))
          ],
          onKeyup: [
            l[3] || (l[3] = j((...S) => r.selectCurrentOption && r.selectCurrentOption(...S), ["enter"])),
            l[4] || (l[4] = j((...S) => r.hide && r.hide(...S), ["esc"]))
          ]
        }, null, 40, Nl)), [
          [P, a.search]
        ]) : n("", !0),
        s("span", Ml, [
          k(d, {
            class: x(["h-5 w-5 transform transition-transform", {
              "text-white": !e.isInvalid && e.transparent,
              "text-gray-400": !e.isInvalid && !e.transparent,
              "text-red-300": e.isInvalid,
              "rotate-180": a.expanded
            }])
          }, null, 8, ["class"])
        ]),
        e.tooltip ? (o(), i("div", Hl, [
          _(k(p, { class: "h-5 w-5 text-gray-400 cursor-help" }, null, 512), [
            [W, { content: e.tooltip, autoHide: !1, html: !0 }]
          ])
        ])) : n("", !0)
      ], 2)
    ]),
    k(Z, {
      "leave-active-class": "transition ease-in duration-100",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: y(() => [
        a.expanded && r.availableOptions.length ? _((o(), i("ul", Tl, [
          (o(!0), i(N, null, L(r.availableOptions, (S, q) => (o(), i(N, {
            key: S.value
          }, [
            S.isDivider ? (o(), u(c, { key: 0 }, {
              default: y(() => [
                O(g(S.label), 1)
              ]),
              _: 2
            }, 1024)) : (o(), u(R, {
              key: 1,
              ref_for: !0,
              ref: `option-${q}`,
              option: S,
              selected: e.values.includes(S.value),
              highlighted: e.searchEnabled && a.selectedIndex === q,
              onMouseenter: ($l) => a.selectedIndex = q,
              onSelect: r.select
            }, null, 8, ["option", "selected", "highlighted", "onMouseenter", "onSelect"]))
          ], 64))), 128))
        ])), [
          [H, { handler: r.hide, capture: !0 }]
        ]) : n("", !0)
      ]),
      _: 1
    })
  ]);
}
const Al = /* @__PURE__ */ v(Vl, [["render", Ol]]), Ll = {
  components: {
    SearchableMultipleSelect: Al
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Search..."
    },
    tooltip: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    help: {
      type: String,
      default: ""
    },
    disabled: Boolean,
    error: {
      type: String,
      default: ""
    },
    transparent: Boolean,
    searchEnabled: {
      type: Boolean,
      default: !0
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  methods: {
    select(t) {
      if (this.modelValue.includes(t)) {
        this.$emit(
          "update:modelValue",
          this.modelValue.filter((l) => l !== t)
        );
        return;
      } else
        this.$emit("update:modelValue", [...this.modelValue, t]);
    }
  }
}, Dl = { class: "w-full" }, Ul = {
  key: 0,
  class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1 mb-2"
}, ql = {
  key: 1,
  class: "mb-2 text-sm ct-text-3"
}, jl = {
  key: 2,
  class: "mt-2 text-sm ct-text-3"
}, Pl = {
  key: 3,
  class: "mt-2 text-sm ct-text-3"
}, Rl = {
  key: 4,
  class: "mt-2 text-sm ct-text-error"
};
function Wl(t, l, e, w, a, r) {
  const f = m("SearchableMultipleSelect");
  return o(), i("div", Dl, [
    e.label ? (o(), i("div", Ul, g(e.label), 1)) : n("", !0),
    t.$slots.description ? (o(), i("div", ql, [
      b(t.$slots, "description")
    ])) : n("", !0),
    k(f, {
      values: e.modelValue,
      title: e.title,
      placeholder: e.placeholder,
      disabled: e.disabled,
      transparent: e.transparent,
      "is-invalid": !!e.error,
      "search-enabled": e.searchEnabled,
      tooltip: e.tooltip,
      options: e.options,
      onInput: r.select
    }, null, 8, ["values", "title", "placeholder", "disabled", "transparent", "is-invalid", "search-enabled", "tooltip", "options", "onInput"]),
    e.options.length < 2 && t.$slots.empty ? (o(), i("p", jl, [
      b(t.$slots, "empty")
    ])) : n("", !0),
    e.help ? (o(), i("p", Pl, g(e.help), 1)) : n("", !0),
    e.error ? (o(), i("p", Rl, g(e.error), 1)) : n("", !0)
  ]);
}
const Gr = /* @__PURE__ */ v(Ll, [["render", Wl]]), Kr = {
  __name: "FormError",
  setup(t) {
    return (l, e) => (o(), u(F, { error: "" }, {
      default: y(() => [
        b(l.$slots, "default")
      ]),
      _: 3
    }));
  }
}, Qr = G, Jr = {
  makeFile: G,
  CROPPER_PRESETS: z
}, Yr = {
  parseToHTMLFromMarkdown: oe,
  parseTestimonialToHTMLFromMarkdown: le,
  preset: re,
  buttons: se
};
export {
  $r as FormAvatar,
  ts as FormCheck,
  jr as FormDivider,
  Kr as FormError,
  ss as FormFiles,
  ls as FormInput,
  Mr as FormInputColor,
  zr as FormInputContainer,
  as as FormInputDate,
  Ur as FormInputDouble,
  Vr as FormInputDropdown,
  Tr as FormInputPostButton,
  Dr as FormInputPostText,
  Er as FormInputPreDropdown,
  ds as FormInputPreIcon,
  Or as FormInputPreSwitch,
  Nr as FormInputPreText,
  qr as FormInputQuantity,
  Wr as FormInputUrl,
  Lr as FormLabel,
  Gr as FormMultipleSelect,
  F as FormNotification,
  ns as FormRichText,
  Cr as FormRow,
  Rr as FormSectionTitle,
  cs as FormSelect,
  Fr as FormSwitch,
  Br as FormTextArea,
  Xr as FormTitle,
  Hr as FormToggleMd,
  fs as FormToggleSm,
  lo as FormVariant,
  Pr as FormVariantCheck,
  Ar as FormVariants,
  Jr as filesModel,
  Qr as makeFileModel,
  Yr as richTextModel
};
